import { IN, LOW_HIGH, NOT_IN } from "./../constant";
export const matchLineOfBusinesses = (item, lineOfBusinesses) => {
  let matches = [];

  const configValue = item.primaryConfigValue.trim();
  const highValue = item.primaryConfig2ndValue?.trim();

  if (item.primaryFormatText === "startsWith") {
    // "startsWith" logic
    matches = lineOfBusinesses.filter((lob) =>
      lob.lineOfBusinessCode.startsWith(configValue)
    );
  } else if (item.primaryFormatText === "startsWithNot") {
    // "startsWithNot" logic
    matches = lineOfBusinesses.filter(
      (lob) => !lob.lineOfBusinessCode.startsWith(configValue)
    );
  } else if (item.primaryFormatText?.toLowerCase() === IN) {
    // "In" logic
    const valuesArray = configValue.split(",").map((val) => val.trim()); // Split by commas and trim spaces
    matches = lineOfBusinesses.filter((lob) =>
      valuesArray.includes(lob.lineOfBusinessCode)
    );
  } else if (item.primaryFormatText?.toLowerCase() === NOT_IN) {
    // "NotIn " logic
    const valuesArray = configValue.split(",").map((val) => val.trim()); // Split by commas and trim spaces
    matches = lineOfBusinesses.filter(
      (lob) => !valuesArray.includes(lob.lineOfBusinessCode)
    );
  } else if (item.primaryFormatText === "Single Value") {
    // "Single Value" logic
    matches = lineOfBusinesses.filter(
      (lob) => lob.lineOfBusinessCode === configValue
    );
  } else if (item.primaryFormatText?.toLowerCase() === LOW_HIGH) {
    matches = lineOfBusinesses.filter((lob) => {
      const lobCode = lob.lineOfBusinessCode.trim();

      // Handle pure numeric comparison
      if (!isNaN(configValue) && !isNaN(highValue)) {
        const lobNumericValue = parseFloat(lobCode);
        return (
          lobNumericValue >= parseFloat(configValue) &&
          lobNumericValue <= parseFloat(highValue)
        );
      }

      // Handle alphanumeric comparison
      return (
        lobCode.localeCompare(configValue) >= 0 &&
        lobCode.localeCompare(highValue) <= 0
      );
    });
  }

  return matches;
};
